import React, { useContext, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
// import NewCampraLogo from '../Img/camptralogo.png'
import { useNavigate } from "react-router-dom";
import back from "../Img/new home.png";
import AdminImg from "../Img/usrpict.PNG";
import Viewer from "../Img/user_8777874.png";
import NotificationImg from "../Img/notification.png";
// import NotificationCircleImg from '../Img/notification-with-number.png'
import {
  IoIosArrowDown,
  IoIosArrowUp,
  IoIosNotifications,
} from "react-icons/io";
import { useState } from "react";
import GlobalContext from "../context/GlobalContext";
import axios from "axios";
import { API_BASE_URL } from "../utils/config";
import AiChat from "../Img/AI-chat.png";
import DasboardImg from "../Img/dasboard.png";
import Modal from "./Modal";
import TanentUser from "../Img/tanent-users.png";

const OpenPlatformNavbar = () => {
  const navigate = useNavigate();
  const rolles = localStorage.getItem("roles");

  const [notificationCircleImg, setNotificationCircleImg] = useState(true);
  // const [chatModal, setChatModal] = useState(false)

  const logOutBtn = () => {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("tags");
    navigate("/");
    window.location.reload();
  };
  // let bearerToken = localStorage.getItem('jwt_token');
  const config = {
    headers: {
      // 'Authorization': `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const {
    logoutModal,
    setLogoutModal,
    setSettingsDropdown,
    settingsDropdown,
    logoUpload,
    notificationCount,
    setNotificationCount,
    chatModal,
    setChatModal,
    showMenu,
    setShowMenu,
  } = useContext(GlobalContext);
  console.log("line45showMenu=", showMenu);
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/image`, {
        headers: {
          // 'Authorization': `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("line33=", res);
        localStorage.setItem("logoImg", res.data);
      });
  }, [logoUpload]);

  const NewCampraLogo = localStorage.getItem("logoImg");
  const backBtn = () => {
    navigate("/table-posts");
  };
  const uploadUsers = () => {
    navigate("/create-new-user-form");
  };
  const HomeBtn = () => {
    localStorage.removeItem("catagoryId");
    navigate("/");
  };
  const WigetTable = () => {
    navigate("/widget-admin");
  };
  const manageLog = () => {
    navigate("/logo");
  };
  const manageBroadCast = () => {
    navigate("/broadcast");
  };

  // useEffect(() => {
  //   // getParentCategories()
  //   axios
  //     .get(
  //       `${API_BASE_URL}/wp-json/custom/v1/get-count/?user_id=${localStorage.getItem(
  //         "current_user_Id"
  //       )}`,
  //       config
  //     )
  //     .then((res) => {
  //       console.log(res);
  //       setNotificationCount(res.data.count_value);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [notificationCount]);
  const notifications = () => {
    let notification_count = {
      user_id: localStorage.getItem("current_user_Id"),
      count_value: 0,
      reflect_count: "set_count",
    };
    // if (notification_count.user_id != "") {
    // post notification on usermeta start
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
        notification_count,
        config
      )
      .then((res) => {
        console.log(res.data);
        setNotificationCount(0);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    navigate("/notification");
    // setNotificationCircleImg(false)
    // NotificationImg = require('../Img/notification.png')
  };
  const chatModalOpen = () => {
    navigate("/analytics-dashboard");
  };
  return (
    <div className="w-100 ">
      <div
        className="header justify-content-between "
        style={{ padding: "0 20px" }}
      >
        <div style={{ cursor: "pointer" }} className="ps-4" onClick={HomeBtn}>
          {/* <button onClick={CollapseSidbarBtn} className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 "><i className="fas fa-bars" ></i></button> */}

          <img
            // width={100}
            style={{ width: "100%", height: "65px" }}
            src={NewCampraLogo}
            alt=""
          />
        </div>

        <div className="d-flex">
          <div className="back-screen ">
            <button
              // data-bs-toggle="modal"
              // data-bs-target="#exampleModal"
              onClick={chatModalOpen}
            >
              <img
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Dashboard"
                width={35}
                src={DasboardImg}
                alt=""
              />
            </button>
          </div>
          <div
            role="button"
            className="manage-users  p-2 rounded "
            onClick={() => navigate("/login")}
          >
            Login
          </div>
        </div>
        {/* } */}
        <Modal />
      </div>
    </div>
  );
};

export default OpenPlatformNavbar;
